import { Component, OnInit } from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {AdminService} from '../../../shared/services/admin.service';
import {EducationService} from '../../../shared/services/education.service';
import {empty, sortArrayOnKey} from '../../../functions';
import {catchError} from 'rxjs/operators';

@Component({
    selector: 'app-modal-admin-educationprogram',
    templateUrl: './modal-admin-educationprogram.component.html',
    styleUrls: ['./modal-admin-educationprogram.component.scss'],
    standalone: false
})
export class ModalAdminEducationprogramComponent implements OnInit {

  public data:any;

  public entity = {
    id: '',
    code: '',
    title: '',
    internationalTitle: '',
    schoolId: null,
    educationLevelId: null
  };

  schoolData: any[] = [];
  educationLevelData: any[] = [];

  /**
   * Constructor
   *
   * @param activeModal
   * @param adminService
   */
  constructor(public activeModal: NgbActiveModal,
              public adminService:AdminService,
              public educationService: EducationService) {

  }

  /**
   * Ng on init
   */
  ngOnInit(): void {

    this.entity = this.data.entity;

    // Get school data to pick from
    this.educationService.apiGetSchools().subscribe( (schools:any) => {

      if (schools) {
        this.schoolData = Object.assign([], schools.data);
      }

    });

    // Get education level data to pick from
    if (this.educationService.educationLevels.length > 0) {
      this.educationLevelData = Object.assign([], this.educationService.educationLevels);
      this.educationLevelData = sortArrayOnKey(this.educationLevelData, 'name');
    } else {
      this.educationService.educationLevelsSubject.subscribe( (educationLevels:any) => {
        this.educationLevelData = Object.assign([], this.educationService.educationLevels);
        this.educationLevelData = sortArrayOnKey(this.educationLevelData, 'name');
      });
    }

  }

  /**
   * Save
   *
   * @constructor
   */
  Save() {

    if (!empty(this.entity.id)) {

      this.adminService.apiUpdateEducationProgram(this.entity).pipe(catchError(this.adminService.handleError('apiUpdateEducationProgram', false))).subscribe( (result) => {

        if (result !== false) {
          this.activeModal.close(true);
        }

      });

    } else {
      const { id, ...body } = this.entity;
      this.adminService.apiAddEducationProgram(body).pipe(catchError(this.adminService.handleError('apiAddEducationProgram', false))).subscribe( (result) => {

        if (result !== false) {
          this.activeModal.close(true);
        }

      });
    }
  }

}
